/**
 * 書式 Edit から AI mypr ダイアログを開閉する入口。
 * visible は呼び出しごとローカル。遠い close のみ mitt HIDE。
 */
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { emitter, HIDE_AI_MYPR_DIALOG } from '@/plugins/emitter'

export function useAiMyprDialogControls() {
  const aiMyprVisible = ref(false)

  function openAiMyprDialog() {
    aiMyprVisible.value = true
  }

  function closeAiMyprDialog() {
    aiMyprVisible.value = false
  }

  function onHideFromRemote() {
    aiMyprVisible.value = false
  }

  onMounted(() => {
    emitter.on(HIDE_AI_MYPR_DIALOG, onHideFromRemote)
  })

  onBeforeUnmount(() => {
    emitter.off(HIDE_AI_MYPR_DIALOG, onHideFromRemote)
  })

  return {
    aiMyprVisible,
    openAiMyprDialog,
    closeAiMyprDialog
  }
}
